import { Numeric1BoxOutlineIcon } from './Numeric1BoxOutlineIcon';

/**
 * author: Google
 * id 50AEDC65-99B1-45CA-8078-CD6D8633995A
 * name numeric-1-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-1-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericOneBoxOutlineIcon = Numeric1BoxOutlineIcon;
export default NumericOneBoxOutlineIcon